import { Controller } from '@hotwired/stimulus';

export default class LastSearchController extends Controller {
    static values = {
        searchFilter: Object,
    };

    get searchFilter() {
        return this.searchFilterValue;
    }

    connect() {
        const jsonData = JSON.stringify(this.searchFilter);

        document.cookie = `lastSearch=${jsonData}; path=/; max-age=34560000`;
    }
}
